import FileCopyOutlinedIcon from "@mui/icons-material/FileCopyOutlined";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import Close from '@mui/icons-material/Close';

import {
    Box,
    Button,
    CircularProgress,
    IconButton,
    TextField,
    Tooltip,
    Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { CustomTabPanel } from ".";
import { useEffect, useRef, useState } from "react";
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import DashboardIcon from "@mui/icons-material/Dashboard";
import Groups2Icon from '@mui/icons-material/Groups2';
import './styles.scss';
import { formatDateToDDMMYYYY } from "src/shared/util/formatDates";
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import { LocationWithoutProduction } from "src/tecnica/utils/getSummary";
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { askGemini } from "src/shared/util/askGemini";
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import DownloadIcon from '@mui/icons-material/Download';
import generatePDF, { Options } from 'react-to-pdf';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { convertArrayOfObjectsToCSV } from "src/shared/util/functions";

const mappedFieldForMessage = [
    { "name": "Cuadrilla", "field": "group_assigned", type: "norepeat", exludeFromGeneral: true, hide: true },
    { "name": "Integrantes", "field": "name", type: "norepeat", exludeFromGeneral: true, hide: true },
    { "name": "Actividad planificada", "field": "flujo", type: "norepeat", hide: true },
    { "name": "Campo", "field": "field", type: "norepeat", exludeFromGeneral: true },

    { "name": "Pozos programados", "field": "pozosProgramados", type: "number" },
    { "name": "Pozos visitados", "field": "pozosVisitados", type: "number" },
    { "name": "Pozos aportando", "field": "pozosAportando", type: "number" },
    { "name": "Pozos operando", "field": "pozosOperando", type: "number" },
    { "name": "Pozos sin aporte", "field": "pozosSinAporte", type: "number" },
    { "name": "Para TDS", "field": "pozosSinProduccion", type: "number" },
    { "name": "Pozos Interrumpidos (IT)", "field": "pozosIT", type: "number" },
    { "name": "Pozos sin acceso", "field": "pozosSinAcceso", type: "number" },
    { "name": "Pozos recolocados", "field": "pozosRecolocado", type: "number" },
    { "name": "Pozos en observación", "field": "pozosEnObservacion", type: "number" },

    { "name": "Pozos reespaceados", "field": "pozosReespaceados", type: "number" },
    { "name": "Pozos restaurados", "field": "pozosRestaurados", type: "number" },

    { "name": "Producción asociada", "field": "produccionMonitoreado", type: "number" },
    { "name": "Producción restaurada", "field": "produccionRestaurada", type: "number" },
    { "name": "Producción diferida", "field": "produccionDiferida", type: "number" },

    { "name": "Cartas Leutert", "field": "estudiosLeutert", type: "number" },
    { "name": "Estudios Echometer", "field": "estudiosEchometer", type: "number" },
    { "name": "Numero Muestras", "field": "muestras", type: "number" },

    { "name": "Comenmtario", "field": "executedPlanningComment", type: "norepeat", fullSize: true },

    // { "name": "Cartas realizadas", "field": "cartasRealizadas", type: "number" },
    // { "name": "Fecha", "field": "fecha", type: "norepeat" },
]

const internalTabs = [
    { "name": "Resumen", "value": "summary", icon: <TextSnippetIcon /> },
    // { "name": "shortChart", "value": "shortChart", icon: <TableRowsIcon /> },
    { "name": "detaileChart", "value": "details", icon: <DashboardIcon /> },
    { "name": "itWells", "value": "PozosSinProduccion", icon: <MoneyOffIcon /> },
]

interface GroupCards {
    grouped: string,
    members: string,
    field: string,
    techology: string,
    executed: number,
    planned: number,
    reespacedWells: number,
    pvExecuted: number,
    potExecuted: number,
    comment: string
}

interface IresponseFromAi {
    well: string,
    conditionSummary: string,
    responsible: string
}

const groupOfCardsDummy = [
    { "grouped": "C-1", "members": "Juan / Pedro", "field": "Bachaquero", "techology": "Echometer", "executed": 10, "planned": 12, "reespacedWells": 3, "pvExecuted": 2, "potExecuted": 450, "comment": "Good performance, needs improvement. Good performance, needs improvement.Good performance, needs improvement. Good performance, needs improvement. Good performance, needs improvement." },
    { "grouped": "C-2", "members": "Luis / Maria ", "field": "Bachaquero", "techology": "Leutert Digital", "executed": 50, "planned": 45, "reespacedWells": 3, "pvExecuted": 2, "potExecuted": 500, "comment": "Exceeded expectations, great job!" },
    { "grouped": "C-3", "members": "Pedro / Ana", "field": "Lagunillas", "techology": "Echometer", "executed": 70, "planned": 30, "reespacedWells": 5, "pvExecuted": 0, "potExecuted": 250, "comment": "Outstanding performance, keep it up." },
    { "grouped": "C-4", "members": "Carlos / Luisabel", "field": "Lagunillas", "techology": "Leutert Digital", "executed": 20, "planned": 40, "reespacedWells": 10, "pvExecuted": 2, "potExecuted": 150, "comment": "Needs improvement in execution." }
]

const ChartComponent = ({ value, messageSummary, start, end }: { value: any, messageSummary: any, start: any, end: any }) => {


    const [groupOfCards, setGroupOfCards] = useState<GroupCards[]>(groupOfCardsDummy)


    useEffect(() => {

        const groupOfCards: GroupCards[] = []

        if (!messageSummary) return

        for (const cuadrilla of Object.keys(messageSummary) || []) {
            const dataCuadrilla = messageSummary[cuadrilla]

            groupOfCards.push({
                grouped: dataCuadrilla['group_assigned']?.replace('cuadrilla', 'C'),
                members: dataCuadrilla['name'],
                field: dataCuadrilla['field'],
                techology: dataCuadrilla['tecnologia'],
                executed: dataCuadrilla['pozosVisitados'],
                planned: dataCuadrilla['pozosProgramados'],
                reespacedWells: dataCuadrilla['pozosReespaceados'],
                pvExecuted: dataCuadrilla['pozosPruebaValvula'],
                potExecuted: dataCuadrilla['produccionMonitoreado'],
                comment: dataCuadrilla['executedPlanningComment']
            })

        }

        setGroupOfCards(groupOfCards)

    }, [messageSummary])



    return (
        <Box sx={{ width: "100%" }}>
            <Grid className="daily-report-card-container">
                {groupOfCards.map((card, index) => (
                    <Box key={index}>
                        <Box className="daily-report-card">
                            <Box className="title-row">{card.grouped} - {card.members}</Box>
                            <Box className="data-row">{card.field} - {card.techology}</Box>
                            <Box className="progress-row">
                                <Box className="value">
                                    {Math.round((card.executed / card.planned) * 100)}% - ({card.executed}/{card.planned})
                                </Box>
                                <Box
                                    className="background-progress"
                                    sx={{
                                        width: `${Math.round((card.executed / card.planned) * 100)}%`,
                                    }}

                                />
                            </Box>
                            <Box>
                                <Box className="detaialed-row">
                                    <Grid className="data-row">Reespaceados</Grid>
                                    <Grid className="data-row">PV</Grid>
                                    <Grid className="data-row">Pot</Grid>
                                </Box>
                                <Box className="detaialed-row">
                                    <Grid className="data-row">{card.reespacedWells}</Grid>
                                    <Grid className="data-row">{card.pvExecuted}</Grid>
                                    <Grid className="data-row">{card.potExecuted} BNPD</Grid>
                                </Box>
                            </Box>
                            <Box className="title-row">Comentario</Box>
                            <Box className="comment-row">{card.comment}</Box>
                        </Box>
                    </Box>
                ))}
            </Grid>
        </Box>
    )
}

const LocationsWithoutProduction = ({ locations, setlocationWithoutProduction }: { locations: LocationWithoutProduction[] | undefined, setlocationWithoutProduction: any }) => {

    const headers = [
        { label: "Pozo", key: "locationName" },
        { label: "Campo", key: "field" },
        { label: "Estado Pozo Final", key: "locationFinalState" },
        // { label: "Comentario", key: "comment" },
        { label: "Condición", key: "conditionSummary" },
        { label: "Responsable", key: "responsible" }
    ]

    const [fields, setFields] = useState<string[]>([])

    const [selectedField, setSelectedField] = useState<string>()

    // const [allLocations, setAllLocations] = useState<LocationWithoutProduction[]>([])

    const [locationsFiltered, setLocationsFiltered] = useState<LocationWithoutProduction[]>([])

    const [locationToModal, setLocationToModal] = useState<LocationWithoutProduction>()

    const [loading, setLoading] = useState<boolean>(false)

    const [responseFromAi, setResponseFromAi] = useState<IresponseFromAi[]>([])

    const targetRef = useRef<any>();

    useEffect(() => {
        const uniqueFields = Array.from(new Set(locations?.map(location => location.field) || []));

        setFields(uniqueFields);
        setSelectedField(uniqueFields[0])

    }, [locations])

    useEffect(() => {

        if (!selectedField) return;

        const filteredLocations = locations?.filter(l => l.field === selectedField)

        setLocationsFiltered(filteredLocations || [])

    }, [selectedField, locations])

    useEffect(() => {
        if (!responseFromAi || responseFromAi.length === 0) return;

        if (!locations || locations.length === 0) return;

        if (responseFromAi.length > 0) {
            const updatedLocations = locations.map(location => {
                const aiResponse = responseFromAi.find(response => response.well === location.locationName);
                if (aiResponse) {
                    return {
                        ...location,
                        conditionSummary: aiResponse.conditionSummary,
                        responsible: aiResponse.responsible
                    };
                }
                return location;
            });
            setlocationWithoutProduction(updatedLocations);
        }

    }, [responseFromAi])


    const onChangeField = (location: string, tag: string, value: any) => {

        const newFilteredLocations: any = [...locationsFiltered]

        const index = newFilteredLocations.findIndex((loc: any) => loc.locationName === location);

        if (index !== -1) {
            newFilteredLocations[index][tag] = value;

            setLocationsFiltered(newFilteredLocations);
        }

    }

    const onClickComment = (location: LocationWithoutProduction) => {
        setLocationToModal(location)
    }

    const onClickAskAi = async () => {

        const firstLocation = locationsFiltered[0]

        const comment = firstLocation["comment"];

        const dataForPrompt = locationsFiltered.map(location => {
            return {
                well: location["locationName"],
                comment: location["comment"]
            }
        })

        const prompt = `requiero que en base a este arreglo ${JSON.stringify(dataForPrompt)} respondas en formato arreglo json con cada objeto, pozo y las propiedades conditionSummary (la cual es resumen de aproximadamente 30 caracteres (puedes sumar mas caracteres para no abreviar palabras peror equiero corto) de la condición de porque el pozo esta parado), responsible (quien es el responsable de la condición del pozo considereando que si es problema de distribucion electrica debes responder "Distribucion", si es problema de operaciones o unidad (problemas de frenos, valvula sonolog, valvula 2da de 4, caja de engranaje, variador) debes responder "Operaciones", si es problema de subsuelo, tds en sitio o esperando tds debes responder "Subsuelo", si es problema de optimizacion o estudios pendientes debes responder "Optimizacion" en el caso especial de ser optimizacion la condicion resumen debe ser algo estilo esperando estudios completos o similares obvia dar gran detalle solo si es responabilidad de optimizacion)`

        setLoading(true)

        const response = await askGemini(prompt)

        setLoading(false)

        setResponseFromAi(response)
    }

    const onClickDownloadPdfV2 = async () => {
        const options: Options = {
            filename: `${selectedField}.pdf`,
            method: 'build',
            page: { format: "letter", orientation: "portrait", margin: { top: 5, right: 22, bottom: 0, left: 22 } },
            overrides: { pdf: { compress: true, format: 'letter' } },
            canvas: { qualityRatio: 0.2 },
        };
        const pdfDoc = await generatePDF(targetRef, options);
        const pdfBlob = pdfDoc.output('blob');
        // Create a link and trigger download
        const url = URL.createObjectURL(pdfBlob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${selectedField}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    const handleDownloadCSV = () => {
        try {

            if (locationsFiltered.length > 0) {

                const dataToExport: any[] = []

                locationsFiltered.forEach((row: any) => {
                    const newRow: any = {};
                    headers.forEach((col) => {
                        newRow[col?.label || col.key] = row[col.key] || "";
                    });

                    dataToExport.push(newRow);
                });

                const csv = convertArrayOfObjectsToCSV(dataToExport);
                const utf8Bom = "\uFEFF"; // UTF-8 BOM
                const csvWithBom = utf8Bom + csv;
                const blob = new Blob([csvWithBom], { type: "text/csv;charset=utf-8;" });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.setAttribute("hidden", "");
                a.setAttribute("href", url);
                const currentTime = new Date().toISOString().replace(/[:.]/g, "-");
                a.setAttribute("download", `list_locations_${currentTime}.csv`);
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            }
        } catch (error) {
            console.log({ error });
        }
    };

    return (
        <>
            {loading && (
                <Box className="loading_container">
                    <CircularProgress size={80} />
                    <Typography variant="h6">Cargando...</Typography>
                </Box>
            )}
            <Box className="locationsWithoutProduction">
                {locationToModal && (
                    <Grid className="modal_comentarios" sx={{ top: "55%" }}>
                        <Grid>
                            <Box className="modal_comentarios_header">
                                <Typography variant="h6">{locationToModal.locationName}</Typography>
                                <IconButton onClick={() => setLocationToModal(undefined)}>
                                    <Close />
                                </IconButton>
                            </Box>
                        </Grid>
                        <Grid className="modal_comentarios_body">
                            {locationToModal.comment}
                        </Grid>
                    </Grid>
                )}
                <Grid className="fields_tabs_container">
                    {fields.map((field, index) => (
                        <Grid key={index} className={`field_tab ${selectedField === field ? "activeButton" : ""}`} onClick={() => setSelectedField(field)}>
                            {field}
                        </Grid>
                    ))}
                </Grid>
                <Grid ref={targetRef}>
                    <Grid>
                        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mb: 1, mt: 1 }}>
                            <IconButton
                                aria-haspopup="true"
                                color="inherit"
                                size="small"
                                onClick={() => handleDownloadCSV()}
                            >
                                <DownloadIcon color="primary" />
                            </IconButton>
                            <IconButton
                                aria-haspopup="true"
                                color="inherit"
                                size="small"
                                onClick={() => onClickDownloadPdfV2()}
                            >
                                <PictureAsPdfIcon color="primary" />
                            </IconButton>
                            <IconButton
                                onClick={() => onClickAskAi()}
                                size="small"
                                sx={{
                                    backgroundColor: "#1976d2",
                                    color: "#fff",
                                    "&:hover": {
                                        backgroundColor: "#1565c0",
                                    },
                                }}
                            >
                                <AutoAwesomeIcon />
                            </IconButton>
                        </Box>
                    </Grid>
                    <Grid
                        className="header_container_locations_without_production">
                        {headers.map((header, index) => (
                            <Grid key={index} className="header">
                                <Typography>
                                    {header.label}
                                </Typography>
                            </Grid>
                        ))}
                    </Grid>
                    <Grid
                        className="body_container"
                    >
                        {locationsFiltered.map((location, index) => (
                            <Grid key={index} className="location_row">
                                <Tooltip title={location["comment"]} arrow>
                                    <Grid className="location_cell" sx={{ cursor: "pointer" }} onClick={() => onClickComment(location)}>
                                        <Typography>
                                            {location["locationName"]}
                                        </Typography>
                                    </Grid>
                                </Tooltip>
                                <Grid className="location_cell" sx={{ cursor: "pointer" }} onClick={() => onClickComment(location)}>
                                    <Typography>
                                        {location["field"]}
                                    </Typography>
                                </Grid>
                                <Grid className="location_cell" sx={{ cursor: "pointer" }} onClick={() => onClickComment(location)}>
                                    <Typography>
                                        {location["locationFinalState"]}
                                    </Typography>
                                </Grid>
                                <Grid className="location_cell">
                                    <input
                                        type="text"
                                        value={location["conditionSummary"] || ""}
                                        onChange={(event) => onChangeField(location.locationName, "conditionSummary", event.target.value)}
                                        style={{ width: "100%" }}
                                    />
                                </Grid>
                                <Grid className="location_cell">
                                    <select
                                        value={location["responsible"] || ""}
                                        style={{ width: "100%" }}
                                        onChange={(event) => onChangeField(location.locationName, "responsible", event.target.value)}
                                    >
                                        <option value="">Seleccionar</option>
                                        <option value="Operaciones">Operaciones</option>
                                        <option value="Distribucion">Distribucion</option>
                                        <option value="Optimizacion">Optimizacion</option>
                                        <option value="Subsuelo">Subsuelo</option>
                                    </select>
                                </Grid>
                            </Grid>
                        ))}
                    </Grid>
                </Grid>
            </Box>
        </>
    )
}

export const SummaryComponent = ({ value, messageSummary, start, end, onClickUpdateTask, activesSquadData, setActivesSquadData, locations, setlocationWithoutProduction }:
    { value: any, messageSummary: any, start: any, end: any, onClickUpdateTask: any, activesSquadData: any, setActivesSquadData: any, locations: LocationWithoutProduction[] | undefined, setlocationWithoutProduction: any }) => {


    const [activesSquad, setActivesSquad] = useState<string[]>(["all"])

    const [activeSummaryView, setactiveSummaryView] = useState(internalTabs[0].value)

    const [dataToShowFromAllFields, setDataToShowFromAllFields] = useState<any>({})

    const [wsMessage, setWsMessage] = useState<any>({ groupMessage: "", individualMessages: [] })


    useEffect(() => {
        let enabledSquad = Object.keys(messageSummary || {})

        enabledSquad = enabledSquad.sort((a, b) => {
            const fieldA = messageSummary[a].field || "unknown_field";
            const fieldB = messageSummary[b].field || "unknown_field";

            if (fieldA < fieldB) return -1;
            if (fieldA > fieldB) return 1;
            return 0;
        })

        if (!activesSquad.includes("all")) {
            enabledSquad = enabledSquad.filter((item) => activesSquad.includes(item))
        }

        const newActivesSquadData: any = {}

        const individualMessages: string[] = []

        let lastFieldFroSquad = ''


        enabledSquad.forEach((item: any) => {

            const fieldForSquad = messageSummary[item].field || "unknown_field";

            if (!newActivesSquadData[fieldForSquad]) {
                const numberOfSquads = Object.keys(messageSummary || {}).filter((item) => messageSummary[item].field === fieldForSquad && enabledSquad.includes(messageSummary[item].name)).length;
                newActivesSquadData[fieldForSquad] = {
                    squatsNumber: numberOfSquads,
                };
            }

            let individualTextMessage = ``

            if (lastFieldFroSquad !== fieldForSquad) {
                individualTextMessage += `*Campo*: ${fieldForSquad}\n\n`
                lastFieldFroSquad = fieldForSquad
            }

            const dataForSquad = messageSummary[item]

            mappedFieldForMessage.forEach((field) => {
                if (field.type === "number" && !isNaN(dataForSquad[field.field])) {
                    newActivesSquadData[fieldForSquad][field.field] = parseFloat(newActivesSquadData[fieldForSquad][field.field] || 0) + parseFloat(dataForSquad[field.field]);
                } else if (field.type === "norepeat") {
                    const preValue = newActivesSquadData[fieldForSquad][field.field];


                    if (preValue === undefined && dataForSquad[field.field] !== undefined) {
                        newActivesSquadData[fieldForSquad][field.field] = `${dataForSquad[field.field]}`;
                    } else if (newActivesSquadData[fieldForSquad][field.field] && !preValue?.includes(dataForSquad[field.field])) {
                        newActivesSquadData[fieldForSquad][field.field] = `${newActivesSquadData[fieldForSquad][field.field]} / ${dataForSquad[field.field] || ""}`;
                    }
                } else {
                    const preValue = newActivesSquadData[fieldForSquad][field.field];

                    if (preValue === undefined) {
                        newActivesSquadData[fieldForSquad][field.field] = dataForSquad[field.field] || " ";
                    } else {
                        newActivesSquadData[fieldForSquad][field.field] = `${newActivesSquadData[fieldForSquad][field.field]} ${dataForSquad[field.field] || ""}`;
                    }
                }

                if (dataForSquad[field.field] !== undefined && dataForSquad[field.field] !== null) {
                    individualTextMessage += `*${field.name}*: ${dataForSquad[field.field]}\n`
                }
            })

            individualMessages.push(individualTextMessage)
        })

        const summaryToShow: any = {}

        Object.keys(newActivesSquadData).forEach((field) => {

            mappedFieldForMessage.forEach((mappedField) => {

                if (!Object.keys(summaryToShow).includes(mappedField.field)) {

                    summaryToShow[mappedField.field] = newActivesSquadData[field][mappedField.field]

                } else {
                    if (typeof summaryToShow[mappedField.field] === "number") {
                        summaryToShow[mappedField.field] += newActivesSquadData[field][mappedField.field] || 0;

                    } else if (typeof summaryToShow[mappedField.field] === "string") {
                        if (newActivesSquadData[field][mappedField.field] !== undefined && newActivesSquadData[field][mappedField.field] !== null) {
                            summaryToShow[mappedField.field] += ` / ${newActivesSquadData[field][mappedField.field]}`;
                        }
                    }
                }

            })
        })

        setDataToShowFromAllFields(summaryToShow)

        const groupMessage = getSummary(newActivesSquadData)

        setWsMessage({ groupMessage, individualMessages })


        setActivesSquadData(newActivesSquadData)

    }, [activesSquad, messageSummary])


    const onClickSquad = (field: string) => {

        if (field === "all") {
            setActivesSquad(["all"])
            return
        } if (activesSquad.includes(field)) {
            const newActivesSquad = activesSquad.filter((item) => item !== field);

            if (newActivesSquad.length === 0) {
                newActivesSquad.push("all")
            }

            setActivesSquad([...newActivesSquad]);
            return
        } else {
            const newActivesSquad = activesSquad.filter((item) => item !== "all");

            setActivesSquad([...newActivesSquad, field]);
            return
        }
    }

    const getSummary = (enableSquadData: any) => {

        const fechaText = start === end ? formatDateToDDMMYYYY(start) : `${formatDateToDDMMYYYY(start)} - ${formatDateToDDMMYYYY(end)}`

        let textMessage = `Buenas tardes, A continuación se anexa reporte consolidado General por Campo para el día: ${fechaText} \n\n`

        for (const field of Object.keys(enableSquadData || {})) {
            textMessage += `*Campo ${field}*\n\n`
            const data = enableSquadData[field];

            textMessage += `*Total Cuadrillas*:  ${data.squatsNumber}\n`
            textMessage += `*Actividad planificada*:  ${data.flujo}\n`
            textMessage += `*Pozos programados*:  ${data.pozosProgramados}\n`
            textMessage += `*Pozos visitados*:  ${data.pozosVisitados}\n`
            textMessage += `*Pozos aportando*:  ${data.pozosAportando + data.pozosOperando + data.pozosRecolocado + data.pozosRestaurados}\n`
            textMessage += `*Pozos sin aporte*:  ${data.pozosSinAporte + data.pozosEnObservacion + data.pozosSinProduccion}\n`
            textMessage += `*Pozos Interrumpidos(IT)*:  ${data.pozosIT}\n`
            textMessage += `*Pozos sin acceso*:  ${data.pozosSinAcceso}\n`

            textMessage += `*Producción asociada*:  ${data.produccionMonitoreado}\n`
            textMessage += `*Producción diferida*:  ${data.produccionDiferida}\n`

            textMessage += `*Cartas leutert*:  ${data.estudiosLeutert}\n`
            textMessage += `*Estudios Echometer*:  ${data.estudiosEchometer}\n`
            textMessage += `*Numero de muestras*:  ${data.muestras}\n`

            textMessage += `\n`
        }

        return textMessage
    }


    const onClickCopy = ({ type }: { type: "all" | "Summary" }) => {

        if (type === "all") {
            const textToCopy = wsMessage.groupMessage
            navigator.clipboard.writeText(textToCopy).then(() => {
                alert('Mensaje copiado al portapapeles');
            }).catch(err => {
                console.error('Error al copiar el mensaje: ', err);
            });

        } else {

            const headerText = `Buenas tardes, a continuación, se describe el resumen de actividades ejecutadas por las cuadrillas de campo NABEP. \n\n`

            const fecha = `*Fecha*: ${start === end ? formatDateToDDMMYYYY(start) : `${formatDateToDDMMYYYY(start)} - ${formatDateToDDMMYYYY(end)}`}\n\n`

            const textToCopy = `${headerText} ${fecha} ${wsMessage.individualMessages.join("\n\n")}`
            navigator.clipboard.writeText(textToCopy).then(() => {
                alert('Mensaje copiado al portapapeles');
            }).catch(err => {
                console.error('Error al copiar el mensaje: ', err);
            });
        }



    }

    const onClickSendWhatsApp = () => {
        const textToCopy = wsMessage.groupMessage + "\n\n" + wsMessage.individualMessages.join("\n\n")

        const phoneNumber = prompt('Ingrese el número de teléfono con el código de país (ej. 584246870497):');
        if (!phoneNumber) {
            alert('Número de teléfono no proporcionado.');
            return;
        }

        // const phoneNumber = '584246870497'; // Reemplaza con el número de teléfono deseado
        if (wsMessage !== "") {
            const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(textToCopy)}`;
            window.open(url, '_blank');
        }
    }

    const onClickOpenActivity = () => {
        onClickUpdateTask(activesSquadData)
    }

    const onClickChangeSummaryView = (tabId: string) => {
        setactiveSummaryView(tabId)
    }

    return (
        <CustomTabPanel value={value} index={0}>
            {/* Buttons */}
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Box sx={{ display: "flex", justifyContent: "flex-start", mt: 3, gap: 2 }}>
                    {
                        internalTabs.map((item, index) => {
                            return (
                                <IconButton
                                    onClick={() => onClickChangeSummaryView(item.value)}
                                    key={index}
                                    className="active_button"
                                    sx={{
                                        backgroundColor: activeSummaryView === item.value ? "#1976d2" : "#f0f0f0",
                                        color: activeSummaryView === item.value ? "#fff" : "#000",
                                        "&:hover": {
                                            backgroundColor: activeSummaryView === item.value ? "#42a5f5" : "#f0f0f0",
                                        },
                                    }}
                                >
                                    {item.icon}
                                </IconButton>
                            )
                        })
                    }
                </Box>
                {/* Buttons Right */}
                <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3, }}>
                    <IconButton
                        onClick={onClickSendWhatsApp}
                        sx={{
                            backgroundColor: "#25D366",
                            color: "#fff",
                            "&:hover": {
                                backgroundColor: "#128C7E",
                            },
                        }}
                    >
                        <WhatsAppIcon />
                    </IconButton>
                    <Tooltip title="Resumen" placement="top">
                        <IconButton
                            onClick={() => onClickCopy({ type: "all" })}
                            sx={{
                                backgroundColor: "#03365e",
                                color: "#fff",
                                "&:hover": {
                                    backgroundColor: "#129ED3",
                                },
                                ml: 2,
                            }}
                        >
                            <FileCopyOutlinedIcon />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Detalle Por Cuadrilla" placement="top">
                        <IconButton
                            onClick={() => onClickCopy({ type: "Summary" })}
                            sx={{
                                backgroundColor: "#98B6DD",
                                color: "#fff",
                                "&:hover": {
                                    backgroundColor: "#129ED3",
                                },
                                ml: 2,
                            }}
                        >
                            <Groups2Icon />
                        </IconButton>
                    </Tooltip>
                    {/* <IconButton
                        onClick={onClickOpenActivity}
                        disabled={activesSquad?.length > 1 || activesSquad.includes("all")}
                        sx={{
                            backgroundColor: "#03365e",
                            color: "#fff",
                            "&:hover": {
                                backgroundColor: "#129ED3",
                            },
                            ml: 2,
                        }}
                    >
                        <OpenInNewIcon />
                    </IconButton> */}
                </Box>
            </Box>

            {/* squads */}
            {activeSummaryView === "summary" && (
                <Grid className="squats_filter_container">
                    <Grid>
                        <Button variant="outlined" fullWidth onClick={() => onClickSquad("all")} className={activesSquad.includes("all") ? "activeButton" : ""} > Todos </Button>
                    </Grid>
                    {Object.keys(messageSummary || {}).map(
                        (key, index) => {

                            let text = `${key} - ${messageSummary[key].group_assigned?.replace("cuadrilla", "c")} - ${messageSummary[key].flujo}`;

                            if (text.length > 70) {
                                text = text.substring(0, 70) + "...";
                            }

                            return (
                                <Button
                                    variant="outlined"
                                    key={index}
                                    onClick={() => onClickSquad(key)}
                                    className={activesSquad.includes(key) ? "activeButton" : ""}
                                    sx={{
                                        height: '130px',
                                        width: '170px', // wider for better readability
                                        minWidth: '130px',
                                        maxWidth: '220px',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        whiteSpace: 'normal', // allow multiline
                                        textAlign: 'center',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        fontSize: '0.95rem',
                                        px: 1, // horizontal padding
                                        py: 1, // vertical padding                                   
                                    }}
                                >
                                    {text}
                                </Button>
                            );
                        }
                    )}
                </Grid>
            )}

            {activeSummaryView === "summary" && (
                <Box sx={{ width: "100%" }}>
                    <Grid container spacing={2} sx={{ mt: 5 }}>
                        {mappedFieldForMessage?.map((item, index) => {

                            if (item.hide) return null;

                            return (
                                <Grid size={item?.fullSize ? 12 : 3} key={index}>
                                    <TextField
                                        id="outlined-basic"
                                        label={item.name}
                                        variant="outlined"
                                        fullWidth
                                        value={dataToShowFromAllFields[item.field] !== undefined && dataToShowFromAllFields[item.field] !== null ? dataToShowFromAllFields[item.field] : " "}
                                    />
                                </Grid>
                            )
                        })}
                    </Grid>
                </Box>
            )}

            {activeSummaryView === "details" && (
                <ChartComponent value={value} messageSummary={messageSummary} start={start} end={end} />
            )}

            {activeSummaryView === "PozosSinProduccion" && (
                <LocationsWithoutProduction locations={locations} setlocationWithoutProduction={setlocationWithoutProduction} />
            )}


        </CustomTabPanel>
    )
}